import { Component } from '@angular/core';
import { HintBaseComponent } from '@shared/modules/hint/components/hint-base/hint-base.component';

@Component({
  selector: 'app-image-hint',
  templateUrl: './image-hint.component.html',
  styleUrls: ['./image-hint.component.scss'],
})
export class ImageHintComponent extends HintBaseComponent {}
